import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import Logo from "@/components/Logo";

const linkCls = "break-words text-sm text-muted-foreground transition-colors hover:text-primary";

const FooterV2 = () => (
  <footer role="contentinfo" className="border-t border-border py-12 md:py-16">
    <div className="mx-auto max-w-[1280px] px-5 md:px-8">
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5">
        <div>
          <Logo variant="full" size="md" />
          <p className="mt-4 max-w-xs text-sm text-muted-foreground">
            Agence créative et partenaire de croissance pour les entreprises de services au Québec.
          </p>
        </div>

        <nav aria-label="Services">
          <h2 className="text-sm font-semibold text-foreground">Services</h2>
          <ul className="mt-4 space-y-2">
            <li><Link to="/reels" className={linkCls}>Reels</Link></li>
            <li><Link to="/podcasts" className={linkCls}>Podcasts</Link></li>
            <li><Link to="/evenements" className={linkCls}>Événements</Link></li>
            <li><Link to="/formations" className={linkCls}>Formations</Link></li>
            <li><Link to="/publicites" className={linkCls}>Publicités</Link></li>
            <li><Link to="/services" className={linkCls}>Tous nos services</Link></li>
          </ul>
        </nav>

        <nav aria-label="Navigation du site">
          <h2 className="text-sm font-semibold text-foreground">Agence</h2>
          <ul className="mt-4 space-y-2">
            <li><Link to="/accompagnement" className={linkCls}>Accompagnement</Link></li>
            <li><Link to="/plan-de-match" className={linkCls}>Plan de match</Link></li>
            <li><Link to="/tarifs" className={linkCls}>Tarifs</Link></li>
            <li><Link to="/portfolio" className={linkCls}>Réalisations</Link></li>
            <li><Link to="/etudes-de-cas" className={linkCls}>Études de cas</Link></li>
          </ul>
        </nav>

        <nav aria-label="Ressources">
          <h2 className="text-sm font-semibold text-foreground">Ressources</h2>
          <ul className="mt-4 space-y-2">
            <li><Link to="/articles/marketing-de-contenu-b2b-quebec-guide-complet" className={linkCls}>Guide marketing de contenu B2B</Link></li>
            <li><Link to="/articles/creation-de-contenu-entreprises-guide-b2b-quebec" className={linkCls}>Guide création de contenu</Link></li>
            <li><Link to="/articles/agence-marketing-b2b-quebec-choisir-partenaire" className={linkCls}>Choisir une agence B2B</Link></li>
            <li><Link to="/articles/marketing-video-b2b-vendre-positionner" className={linkCls}>Marketing vidéo B2B</Link></li>
            <li><Link to="/articles" className={linkCls}>Tous les articles</Link></li>
          </ul>
        </nav>

        <div>
          <h2 className="text-sm font-semibold text-foreground">Coordonnées</h2>
          <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
            <li><a href="mailto:maxim@agence8020.com" className={linkCls}>maxim@agence8020.com</a></li>
            <li>Studio à Mascouche, Québec</li>
          </ul>
          <h2 className="mt-6 text-sm font-semibold text-foreground">Suivez-nous</h2>
          <div className="mt-3 flex items-center gap-3">
            <a href="https://www.instagram.com/agence.8020/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="rounded-lg p-2 text-muted-foreground transition-colors hover:bg-secondary hover:text-primary"><Instagram className="h-5 w-5" /></a>
            <a href="https://www.facebook.com/profile.php?id=61582833982758" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="rounded-lg p-2 text-muted-foreground transition-colors hover:bg-secondary hover:text-primary"><Facebook className="h-5 w-5" /></a>
            <a href="https://youtube.com/@agence8020" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="rounded-lg p-2 text-muted-foreground transition-colors hover:bg-secondary hover:text-primary"><Youtube className="h-5 w-5" /></a>
          </div>
        </div>
      </div>


      <div className="mt-10 flex flex-col gap-4 border-t border-border pt-7 md:mt-12 md:pt-8 md:flex-row md:items-center md:justify-between">
        <nav aria-label="Mentions légales" className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/politique-confidentialite" className={linkCls}>Politique de confidentialité</Link>
          <Link to="/politique-confidentialite" className={linkCls}>Conditions d'utilisation</Link>
          <button
            type="button"
            onClick={() => {
              try {
                localStorage.removeItem("cookie-consent");
              } catch {
                /* stockage indisponible */
              }
              window.location.reload();
            }}
            className={linkCls}
          >
            Gestion des témoins
          </button>
        </nav>
        <span className="text-sm text-muted-foreground">© {new Date().getFullYear()} Agence 8020. Tous droits réservés.</span>
      </div>
    </div>
  </footer>
);

export default FooterV2;
